import { createStore } from '@toolkit/store-generator';

type Error = string | null;

const store = createStore<Error>(null);

const setResettingError = (message: string) => {
  store.set(message);
  setTimeout(() => {
    store.set(null);
  }, 5000);
};

const setPermenantError = (message: string) => {
  store.set(message);
};

const clearError = () => {
  store.set(null);
};

export { store, setResettingError, setPermenantError, clearError, type Error };
